import { createSelector } from 'reselect'

import { selectWelcomeFlowState } from './selectWelcomeFlowState'

export const selectWelcomeFlowRtmList = createSelector(
  [selectWelcomeFlowState],
  (state) => state.RtmList
)
